<template>
    <div class="input-group">
        <b-input-group>
<!--            <div class="input-group-prepend">-->
<!--                <span class="input-group-text"><i class="dripicons-search"></i></span>-->
<!--            </div>-->
            <b-form-input v-on:keyup.enter="handleFilter"
                          type="text"
                          v-model="searchText"
                          autocomplete="off"
                          :placeholder="title"
                          required>
            </b-form-input>
            <b-button @click="handleFilter" class="input-group-append btn-search" variant="orange">
                Search
            </b-button>
        </b-input-group>
    </div>
</template>

<script>
  export default {
    props: {
      title: String,
    },

    data() {
      return {
        searchText: ''
      }
    },

    methods: {
      handleFilter() {
        this.$emit('filterTriggered', this.searchText);
      }
    }
  }
</script>

<style>
    .btn-search {
        border-top-left-radius: 0;
        border-bottom-left-radius: 0;
    }
</style>



// WEBPACK FOOTER //
// src/components/SearchInput.vue